import React from 'react'
import { DownloadCSVButton } from 'front-end/src/components/common/download-csv-button/DownloadCSVButton'
import { Trans } from '@lingui/macro'
import { ButtonOutline } from 'front-end/src/components'
import type { useDisclosure } from '@chakra-ui/hooks/dist/types/use-disclosure'
import { EventQueryAccessor } from '../../helpers'
import { useManageEventContext } from '../../../ManageEventContext'
import { ExportEventInviteesDocument } from './AttendanceTab.codegen'
import { prepareCSVEventAttendExport } from './csv-event-attend'
import { IInviteesFilter } from '../../types/IInvitee'

type ExportEventAttendenceCsvButtonProps = {
  disclosure: Pick<ReturnType<typeof useDisclosure>, 'onOpen'>
  count: number
  filters: IInviteesFilter[]
}

export const ExportEventAttendanceCsvButton: React.FC<ExportEventAttendenceCsvButtonProps> =
  ({ count, disclosure, filters }) => {
    const { event, isRecurringSeries } = useManageEventContext()
    if (isRecurringSeries) {
      return (
        <ButtonOutline
          ml="8px"
          onClick={disclosure.onOpen}
          dataTest="ExportDataButton"
        >
          <Trans>Export data (.csv) </Trans>
        </ButtonOutline>
      )
    }

    return (
      <DownloadCSVButton
        count={count}
        fileName={'event-invitees'}
        dataPath={`data.admin.${EventQueryAccessor.event}.inviteesIncludingIndirect.items`}
        // cos we already queried all data at BE from DB, so don't need to chunk fetched data
        customBatchSize={count}
        queryOptions={(page, limit) => ({
          fetchPolicy: 'no-cache',
          variables: {
            eventId: event.id,
            filters: filters,
            limit,
            offset: (page - 1) * limit
          },
          query: ExportEventInviteesDocument
        })}
        prepareData={prepareCSVEventAttendExport}
      />
    )
  }
